import styled from "styled-components"

export const NewsDetailWrapper = styled.div`
.news-detail {
    padding-top: 22px;
    &_body {
        padding: 12px;
        margin-top: 22px;
        border-radius: 4px;
        background-color:#fff;
        min-height: 700px;
        &_title {
            font-size: 1.6rem;
            color: #1c1c1c;
            font-weight: 500;
            border-bottom: 1px solid #e2c1c1;
            padding-bottom: 12px;
        }
        &_author {
            font-size: 0.8rem;
            color: #626060;
            strong {
                color: #2f80ed;
            }
        }
        &_content {
            img {
                max-width: 100%;
                height: auto;
            }
        }
    }
}

`

